module.exports = __webpack_public_path__ + "static/banner-8-dc2abd8d34aa5d799adb19637703596b.jpg";